import React, { useLayoutEffect, useState } from 'react';

// Components
import { Mui } from 'components';

const useStyles = Mui.makeStyles(theme => ({
  root: {
    position: 'sticky',
    bottom: theme.spacing(3),
    display: 'flex',
    justifyContent: 'center',
    pointerEvents: 'none',
    zIndex: theme.zIndex.appBar - 1,
  },
  button: {
    borderRadius: 99,
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[3],
    pointerEvents: 'auto',
    '&:hover': { backgroundColor: theme.palette.background.paper },
  },
}));

function BackToTop() {
  // Hooks
  const classes = useStyles();

  // States
  const [content, setContent] = useState(null);

  // Effects
  useLayoutEffect(() => setContent(document.getElementById('content')), []);

  // Constants
  const trigger = Mui.useScrollTrigger({
    target: content || undefined,
    disableHysteresis: true,
    threshold: 240,
  });

  // Actions
  const handleClick = () => content?.scroll({ left: 0, top: 0, behavior: 'smooth' });

  if (!content) return null;

  return (
    <div className={classes.root}>
      <Mui.Fade in={trigger}>
        <Mui.Button
          variant="outlined"
          size="small"
          className={classes.button}
          startIcon={<Mui.Icon fontSize="small">arrow_upward</Mui.Icon>}
          onClick={handleClick}>
          Voltar ao topo
        </Mui.Button>
      </Mui.Fade>
    </div>
  );
}

export default BackToTop;
